import {
  baseComponent
} from "./chunk-M4TTTBT7.mjs";

// src/utils/createComponentTheme.ts
import deepmerge from "deepmerge";
var createComponentTheme = (theme, partialTheme) => {
  return deepmerge(baseComponent(theme), partialTheme != null ? partialTheme : {});
};

export {
  createComponentTheme
};
